import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { ExternalLink } from 'lucide-react';

/**
 * Help Accordion Component  
 * Step-by-step configuration instructions
 */
const HelpAccordion: React.FC = () => {
    return (
        <Card className="mt-4">
            <Card.Header>
                <h6 className="mb-0">📖 Como Configurar</h6>
            </Card.Header>
            <Card.Body className="p-0">
                <Accordion flush>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Passo 1: Criar App no Meta Developers</Accordion.Header>
                        <Accordion.Body>
                            <ol>
                                <li>Acesse o <a href="https://developers.facebook.com/" target="_blank" rel="noreferrer">
                                    Meta for Developers <ExternalLink size={14} />
                                </a> e faça login.</li>
                                <li>Vá em "Meus Apps" e clique em <strong>Criar App</strong>.</li>
                                <li>Selecione o tipo <strong>"Outro"</strong> (ou "Empresa").</li>
                                <li>Selecione <strong>"Empresa"</strong> como tipo de aplicativo.</li>
                                <li>Preencha o nome do App (ex: "Y-Agenda Integration") e crie o app.</li>
                            </ol>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Passo 2: Adicionar Produto WhatsApp</Accordion.Header>
                        <Accordion.Body>
                            <ol>
                                <li>No painel do app, procure por "WhatsApp" e clique em <strong>Configurar</strong>.</li>
                                <li>Selecione (ou crie) uma conta empresarial (Meta Business Account).</li>
                                <li>Após configurar, você verá a seção "API de Configuração" no menu lateral esquerdo.</li>
                            </ol>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Passo 3: Obter Credenciais</Accordion.Header>
                        <Accordion.Body>
                            <p>Na tela "Configuração da API" do WhatsApp:</p>
                            <ul>
                                <li><strong>Phone Number ID:</strong> Copie o "Identificação do número de telefone".</li>
                                <li><strong>Token de Acesso:</strong>
                                    <ul>
                                        <li>Para testes: Copie o "Token de acesso temporário".</li>
                                        <li>Para produção: Crie um "Usuário do Sistema" no Business Manager e gere um token permanente.</li>
                                    </ul>
                                </li>
                            </ul>
                            <p className="text-muted">Cole esses valores nos campos acima e clique em "Gerar" no campo Verification Token.</p>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Passo 4: Configurar Webhook</Accordion.Header>
                        <Accordion.Body>
                            <ol>
                                <li>No menu lateral do Meta, vá em <strong>WhatsApp &gt; Configuração</strong>.</li>
                                <li>Em "Webhook", clique em <strong>Editar</strong>.</li>
                                <li><strong>URL de Retorno:</strong> Cole a URL exibida acima.</li>
                                <li><strong>Token de Verificação:</strong> Cole o Verification Token gerado.</li>
                                <li>Clique em "Verificar e Salvar".</li>
                                <li>Após salvar, clique em "Gerenciar" e inscreva-se em <strong>messages</strong>.</li>
                            </ol>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Passo 5: Criar Templates (Opcional)</Accordion.Header>
                        <Accordion.Body>
                            <p>Para iniciar conversas (notificações), o WhatsApp exige Templates aprovados.</p>
                            <ol>
                                <li>No Gerenciador do WhatsApp, vá em "Modelos de Mensagem".</li>
                                <li>Crie templates para cada tipo de notificação que deseja enviar.</li>
                                <li>Após aprovados, copie os <strong>nomes exatos</strong> e insira na seção "Mapeamento de Templates".</li>
                            </ol>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card.Body>
        </Card>
    );
};

export default HelpAccordion;
